import { JSX } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { TReplaceOptions } from 'cng-common/features/translations/components/translation/models/replaceOptions'

import { NoteWrapper } from '../notes/noteWrapper/NoteWrapper'

import { SizedTitle } from './SizedTitle'
import { TitleWrapper } from './titleWrapper/TitleWrapper'

import styles from './Title.module.scss'

interface IProps {
  align?: 'left' | 'right' | 'center'
  text: string
  translationReplaceParams?: TReplaceOptions[]
  companyName?: string
  companyNamePosition?: 'start' | 'end'
  fYear?: number
  size?: 'h3' | 'paragraph'
  variant?: 'withBackground' | 'withLightBackground' | 'default'
  noteContent?: () => JSX.Element
  rightContent?: JSX.Element
  className?: string
}

export const Title = ({
  text,
  translationReplaceParams,
  companyName,
  companyNamePosition = 'start',
  fYear,
  size = 'paragraph',
  align = 'left',
  variant = 'default',
  noteContent,
  rightContent,
  className,
}: IProps) => {
  if (companyName) {
    return (
      <TitleWrapper
        rightContent={rightContent}
        variant={variant}
        align={align}
        className={className}
      >
        <div className={styles.item}>
          <NoteWrapper noteContent={noteContent}>
            <SizedTitle size={size} align={align} variant={variant}>
              {companyNamePosition === 'start' ? <span>{companyName}&nbsp;</span> : null}
              <Translation text={text} replaceParams={translationReplaceParams} />
              {companyNamePosition === 'end' ? <span>&nbsp;{companyName}</span> : null}
            </SizedTitle>
          </NoteWrapper>
        </div>
      </TitleWrapper>
    )
  }
  if (fYear) {
    return (
      <TitleWrapper
        rightContent={rightContent}
        variant={variant}
        align={align}
        className={className}
      >
        <NoteWrapper noteContent={noteContent}>
          <SizedTitle size={size} align={align} variant={variant}>
            <Translation text={text} replaceParams={translationReplaceParams} span />
            <span>&nbsp;(FY'{fYear})</span>
          </SizedTitle>
        </NoteWrapper>
      </TitleWrapper>
    )
  }
  return (
    <TitleWrapper rightContent={rightContent} variant={variant} align={align} className={className}>
      <NoteWrapper noteContent={noteContent}>
        <SizedTitle size={size} align={align} variant={variant}>
          <Translation text={text} replaceParams={translationReplaceParams} />
        </SizedTitle>
      </NoteWrapper>
    </TitleWrapper>
  )
}
